"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.PureFooter = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var CommentsActions = _interopRequireWildcard(require("../../actions/comments"));

var ContextActions = _interopRequireWildcard(require("../../actions/context"));

var _selectors = require("../../selectors");

var _constants = require("../../constants");

var _Footer = _interopRequireDefault(require("./Footer.scss"));

var _GlobalCommentingSwitch = _interopRequireDefault(require("./GlobalCommentingSwitch"));

var _AnnotationToggle = _interopRequireDefault(require("./AnnotationToggle"));

var _NetworkIndicator = _interopRequireDefault(require("./NetworkIndicator"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _CallbackContext = _interopRequireDefault(require("../../context/CallbackContext"));

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _Wait = _interopRequireDefault(require("@react/react-spectrum/Wait"));

var _reducers = require("../../reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var Footer = function Footer(_ref) {
  var commentsFilterClear = _ref.commentsFilterClear,
      commentsFilterTime = _ref.commentsFilterTime,
      commentsFilterUsers = _ref.commentsFilterUsers,
      commentsSetShowAnnotations = _ref.commentsSetShowAnnotations,
      disableFooterControls = _ref.disableFooterControls,
      canFilterComments = _ref.canFilterComments,
      filterTime = _ref.filterTime,
      filterUsers = _ref.filterUsers,
      filteredCommentsCount = _ref.filteredCommentsCount,
      globalComments = _ref.globalComments,
      isAnnotationsVisible = _ref.isAnnotationsVisible,
      isFilterOn = _ref.isFilterOn,
      multiPageAsset = _ref.multiPageAsset,
      setUnmappedView = _ref.setUnmappedView,
      showResolvedComments = _ref.showResolvedComments,
      showGlobalCommentsToggle = _ref.showGlobalCommentsToggle,
      toggleResolved = _ref.toggleResolved,
      users = _ref.users,
      viewingUnmapped = _ref.viewingUnmapped,
      visible = _ref.visible,
      isOffline = _ref.isOffline,
      isMapping = _ref.isMapping;

  var _useContext = (0, _react.useContext)(_CallbackContext.default),
      onAnnotationToggle = _useContext.onAnnotationToggle;

  var _useContext2 = (0, _react.useContext)(_AppContext.default),
      annotationsEnabled = _useContext2.annotationsEnabled,
      annotationsMultiPageEnabled = _useContext2.annotationsMultiPageEnabled,
      compactLayout = _useContext2.compactLayout,
      touchControls = _useContext2.touchControls,
      disableNetworkIndicator = _useContext2.disableNetworkIndicator,
      globalCommentsToggle = _useContext2.globalCommentsToggle;

  var isAnnotationsToggleVisible = canFilterComments && annotationsEnabled;
  var isGlobalCommentingSwitchVisible = showGlobalCommentsToggle && !annotationsMultiPageEnabled;
  var globalCommentsMode = Boolean(globalComments && multiPageAsset && globalCommentsToggle.isActive);
  return visible ? /*#__PURE__*/_react.default.createElement("footer", {
    "aria-labelledby": "footer-heading",
    className: _Footer.default.component,
    id: "ccx-comments-filter"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "visually-hidden",
    id: "footer-heading"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.sections.commentListFooter"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-container"
  }, /*#__PURE__*/_react.default.createElement(_GlobalCommentingSwitch.default, {
    defaultChecked: globalCommentsToggle.isActive,
    disable: disableFooterControls,
    globalCommentsMode: globalCommentsMode,
    onToggle: globalCommentsToggle.onToggle,
    setUnmappedView: setUnmappedView,
    viewingUnmapped: viewingUnmapped,
    visible: isGlobalCommentingSwitchVisible
  }), !isGlobalCommentingSwitchVisible && !compactLayout && !disableNetworkIndicator ? /*#__PURE__*/_react.default.createElement(_NetworkIndicator.default, {
    isOffline: isOffline
  }) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "toggle-right-container"
  }, isMapping ? /*#__PURE__*/_react.default.createElement("div", {
    className: "mapping-indicator"
  }, /*#__PURE__*/_react.default.createElement(_Wait.default, {
    size: "S"
  })) : /*#__PURE__*/_react.default.createElement(_AnnotationToggle.default, {
    commentsSetShowAnnotations: commentsSetShowAnnotations,
    disable: disableFooterControls,
    isAnnotationsVisible: isAnnotationsVisible,
    onAnnotationToggle: onAnnotationToggle,
    visible: isAnnotationsToggleVisible
  }), /*#__PURE__*/_react.default.createElement(_Filter.default, {
    commentsFilterClear: commentsFilterClear,
    commentsFilterTime: commentsFilterTime,
    commentsFilterUsers: commentsFilterUsers,
    disable: disableFooterControls,
    filteredCommentsCount: filteredCommentsCount,
    filterTime: filterTime,
    filterUsers: filterUsers,
    isFilterOn: isFilterOn,
    showResolvedComments: showResolvedComments,
    toggleResolved: toggleResolved,
    touchControls: touchControls,
    users: users,
    visible: canFilterComments
  }), isGlobalCommentingSwitchVisible && !disableNetworkIndicator ? /*#__PURE__*/_react.default.createElement(_NetworkIndicator.default, {
    isOffline: isOffline,
    tooltipDirection: "left"
  }) : null))) : null;
};

exports.PureFooter = Footer;
Footer.defaultProps = {
  disableFooterControls: false,
  filteredCommentsCount: 0,
  filterUsers: [],
  isMapping: false,
  isOffline: false,
  users: [],
  viewingUnmapped: false
};
Footer.propTypes = {
  canFilterComments: _propTypes.default.bool.isRequired,
  commentsFilterClear: _propTypes.default.func.isRequired,
  commentsFilterTime: _propTypes.default.func.isRequired,
  commentsFilterUsers: _propTypes.default.func.isRequired,
  commentsSetShowAnnotations: _propTypes.default.func.isRequired,
  disableFooterControls: _propTypes.default.bool,
  filteredCommentsCount: _propTypes.default.number,
  filterTime: _propTypes.default.array.isRequired,
  filterUsers: _propTypes.default.array,
  globalComments: _propTypes.default.bool.isRequired,
  isAnnotationsVisible: _propTypes.default.bool.isRequired,
  isFilterOn: _propTypes.default.bool.isRequired,
  isMapping: _propTypes.default.bool,
  isOffline: _propTypes.default.bool,
  multiPageAsset: _propTypes.default.bool.isRequired,
  setUnmappedView: _propTypes.default.func.isRequired,
  showGlobalCommentsToggle: _propTypes.default.bool.isRequired,
  showResolvedComments: _propTypes.default.bool.isRequired,
  toggleResolved: _propTypes.default.func.isRequired,
  users: _propTypes.default.array,
  viewingUnmapped: _propTypes.default.bool,
  visible: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var compactLayout = ownProps.compactLayout,
      globalComments = ownProps.globalComments,
      isOffline = ownProps.isOffline,
      isMapping = ownProps.isMapping,
      assetData = ownProps.assetData,
      filterComments = ownProps.filterComments;
  var comments = (0, _selectors.getFilteredComments)(state, ownProps);
  var canFilterComments = !compactLayout && filterComments;
  var filterTime = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.filterTime"));
  var filterUsers = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.filterUsers"));
  var focusedInputInfo = compactLayout ? (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.focusedInputInfo")) : undefined;
  var isAnnotationsVisible = !compactLayout && (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.showAnnotations"));
  var showResolvedComments = !compactLayout && (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.showResolvedComments"));
  var commentCounts = (0, _selectors.getCommentCounts)(state, ownProps);
  var hasUnmapped = Boolean((0, _lodash.default)(commentCounts, "allNodes.".concat(_constants.UNMAPPED_GLOBAL_ID)));
  var multiPageAsset = Boolean(assetData.validNodes && (assetData.validNodes.length > 1 || hasUnmapped));
  var hasResolvedComments = (0, _selectors.getHasResolvedComments)(state, ownProps);
  var showGlobalCommentsToggle = Boolean(globalComments && multiPageAsset);
  var visible = (canFilterComments || showGlobalCommentsToggle) && (!compactLayout || !focusedInputInfo || !focusedInputInfo[assetData.nodeId]);
  var disableFooterControls = commentCounts.total.unresolved === 0 && !hasResolvedComments;
  return {
    disableFooterControls: disableFooterControls,
    canFilterComments: canFilterComments,
    filterTime: filterTime,
    filterUsers: filterUsers,
    filteredCommentsCount: comments ? comments.length : 0,
    hasResolvedComments: hasResolvedComments,
    isFilterOn: canFilterComments && (filterUsers.length > 0 || filterTime.length > 0 || showResolvedComments),
    isAnnotationsVisible: isAnnotationsVisible,
    multiPageAsset: multiPageAsset,
    showResolvedComments: showResolvedComments,
    showGlobalCommentsToggle: showGlobalCommentsToggle,
    users: (0, _selectors.getFilterableUsers)(state, ownProps),
    viewingUnmapped: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.viewingUnmapped")),
    visible: visible,
    isOffline: isOffline,
    isMapping: isMapping
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    commentsFilterClear: CommentsActions.commentsFilterClear,
    commentsFilterTime: CommentsActions.commentsFilterTime,
    commentsFilterUsers: CommentsActions.commentsFilterUsers,
    commentsSetShowAnnotations: CommentsActions.commentsSetShowAnnotations,
    setUnmappedView: ContextActions.contextSetUnmappedView,
    toggleResolved: CommentsActions.toggleResolved
  }, dispatch);
};

exports.mapDispatchToProps = mapDispatchToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
})(Footer);

exports.default = _default;